import { observer } from 'mobx-react-lite';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import type { ApplicationSdk } from '../../../core/sdk';
import SystemSettingStore from '../stores/SystemSettingStore';

const S3Settings = observer(
    ({ store, sdk }: { store: SystemSettingStore; sdk: ApplicationSdk }) => {
        const handleEditS3Settings = async () => {
            await sdk.getDialogMultiInput({
                title: 'S3 Einstellungen bearbeiten',
                message: 'Hier können Sie die S3 Konfiguration bearbeiten.',
                fields: [
                    {
                        key: 'accessKeyId',
                        label: 'Access Key ID',
                        type: 'text',
                        placeholder: 'Geben Sie Ihre Access Key ID ein',
                        required: true,
                    },
                    {
                        key: 'secretAccessKey',
                        label: 'Secret Access Key',
                        type: 'text',
                        placeholder: 'Geben Sie Ihre Secret Access Key ein',
                        required: true,
                    },
                    {
                        key: 'bucketName',
                        label: 'Bucket Name',
                        type: 'text',
                        placeholder: 'Geben Sie Ihren Bucket Namen ein',
                        required: true,
                    },
                    {
                        key: 'folderName',
                        label: 'Ordner Name',
                        type: 'text',
                        placeholder: 'Geben Sie Ihren Ordner Namen ein',
                        required: true,
                    },
                    {
                        key: 'endpoint',
                        label: 'S3 Endpunkt ( Format: https://s3.example.com )',
                        type: 'text',
                        placeholder: 'Geben Sie Ihren S3 Endpunkt ein',
                        required: true,
                    },
                    {
                        key: 'region',
                        label: 'S3 Region ( z.B. us-east-1 )',
                        type: 'text',
                        placeholder: 'Geben Sie Ihren S3 Region ein',
                        required: true,
                    },
                ],
                initialValue: {
                    accessKeyId: store.s3Config?.accessKeyId || '',
                    secretAccessKey: store.s3Config?.secretAccessKey || '',
                    bucketName: store.s3Config?.bucketName || '',
                    folderName: store.s3Config?.folderName || '',
                    endpoint: store.s3Config?.endpoint || '',
                    region: store.s3Config?.region || '',
                },
                onConfirm: async (values: any) => store.saveS3Settings(values),
            });
        };

        const s3Settings = [
            {
                label: 'Access Key ID',
                value: store.s3Config?.accessKeyId || 'Nicht konfiguriert',
                key: 'S3_ACCESS_KEY_ID',
            },
            {
                label: 'Secret Access Key',
                value: store.s3Config?.secretAccessKey ? '***********' : 'Nicht konfiguriert',
                key: 'S3_SECRET_ACCESS_KEY',
            },
            {
                label: 'Bucket Name',
                value: store.s3Config?.bucketName || 'Nicht konfiguriert',
                key: 'S3_BUCKETNAME',
            },
            {
                label: 'Folder Name',
                value: store.s3Config?.folderName || 'Nicht konfiguriert',
                key: 'S3_FOLDERNAME',
            },
            {
                label: 'Endpoint',
                value: store.s3Config?.endpoint || 'Nicht konfiguriert',
                key: 'S3_ENDPOINT',
            },
            {
                label: 'Region',
                value: store.s3Config?.region || 'Nicht konfiguriert',
                key: 'S3_REGION',
            },
        ];

        return (
            <Card
                title="S3 Einstellungen"
                style={{
                    marginBottom: '1rem',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                }}
            >
                <div className="p-fluid">
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        {s3Settings.map(setting => (
                            <div key={setting.key}>
                                <label
                                    style={{
                                        display: 'block',
                                        marginBottom: '0.5rem',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {setting.label}:
                                </label>
                                <p
                                    style={{
                                        margin: 0,
                                        padding: '0.5rem',
                                        backgroundColor: '#f8f9fa',
                                        borderRadius: '4px',
                                        color:
                                            setting.value === 'Nicht konfiguriert'
                                                ? '#666'
                                                : '#333',
                                        fontFamily: setting.value.includes('***')
                                            ? 'monospace'
                                            : 'inherit',
                                    }}
                                >
                                    {setting.value}
                                </p>
                            </div>
                        ))}

                        {/* Action Button */}
                        <div
                            style={{
                                display: 'flex',
                                gap: '0.5rem',
                                justifyContent: 'flex-end',
                                marginTop: '1rem',
                            }}
                        >
                            <Button
                                label="Bearbeiten"
                                icon="pi pi-pencil"
                                onClick={handleEditS3Settings}
                                className="p-button-outlined"
                                style={{ padding: '0.5rem 1rem' }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        );
    }
);

export default S3Settings;
